import GoodsPage from "./GoodsPage";
import PostCardMobile from "./mobile/PostCardMobile";
import React, { useEffect, useState } from "react";
import { useIsMobile } from "../../hooks/useIsMobile";
import { getPostCard, setPostCardLike } from "../../api/index";
import Alert from "../../common/layouts/modal/Alert";
import { useLoading } from "../../common/controls/LoadingContext";
import usePageTitle from "../../hooks/usePageTitle";


const PostCardContainer = () => {
    const isMobile = useIsMobile();
    const { showLoading, hideLoading } = useLoading();

    const [postCardList, setPostCardList] = useState<any>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [itemsPerPage, setItemsPerPage] = useState(12);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [selectedGenreIndex, setSelectedGenreIndex] = useState(0);
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    useEffect(() => {
        const getData = async () => {
            try {
                showLoading();
                const data = await getPostCard(currentPage, itemsPerPage, selectedGenreIndex);
                setTotalPages(data.totalPages);
                setPostCardList(data);
            } catch (e) {
                console.error("엽서 데이터 로드 실패:", e);
            } finally {
                hideLoading();
                setIsDataLoaded(true);
            }

        };
        getData();

    }, [currentPage, itemsPerPage, selectedGenreIndex])

    // 검색엔진 노출용 설명: 각 작가의 엽서명(설명)을 나열해 "Image N" 같은 의미 없는 텍스트 대신 실제 엽서 정보가 보이게 함
    const seoDescription = React.useMemo(() => {
        const content = postCardList?.content;
        if (!Array.isArray(content) || content.length === 0) {
            return "북밋에서 작가님들의 엽서를 만나보세요.";
        }
        const entries = content
            .slice(0, 5)
            .map((post: any) => post.postCardDescription
                ? `${post.authorName} - ${post.postCardDescription}`
                : post.authorName)
            .filter(Boolean);
        return `${entries.join(', ')} 등 작가님들의 엽서를 북밋에서 만나보세요.`;
    }, [postCardList]);

    usePageTitle("북밋 엽서 소개", seoDescription, isDataLoaded);

    const handlePageChange = (newPage: number) => {
        setCurrentPage(newPage);
    };

    const toggleLike = async (postId: string) => {
        try {
            const authorStatus: string | null = localStorage.getItem("authorStatus");
            if (authorStatus && authorStatus.toLowerCase() === "hold") {
                setAlertMessage("현재 계정 이용이 제한된 상태입니다.\n운영 정책 위반으로 인해\n좋아요 기능이 제한되었습니다.\n기존 게시글은 수정 후 안내 메일에 따라 재검토 요청이 가능합니다.");
                setShowAlert(true);
                return;
            }
            const authorEmail: string | null = localStorage.getItem("email");

            const post = postCardList?.content?.find((p: any) => p.postCardId === postId);
            const postAuthorEmail = post.authorEmail;


            const authorYn: boolean = !!authorStatus && authorEmail != postAuthorEmail;

            if (!authorStatus || !authorYn) {
                const alertMessage =
                    !authorStatus ? "로그인이 필요합니다."
                        : !authorYn ? "본인 작품은 좋아요할 수 없습니다."
                            : "";

                setAlertMessage(alertMessage);
                setShowAlert(true);
                return;
            }

            await setPostCardLike(postId);

            setPostCardList((prevList: any) => {
                if (!prevList || !Array.isArray(prevList.content)) {
                    return prevList;
                }

                const updatedContent = prevList.content.map((post: any) => {
                    if (post.postCardId === postId) {
                        const isLiked = post.like ?? false;
                        const newLikeCount = isLiked
                            ? (post.likeCount ?? 0) - 1
                            : (post.likeCount ?? 0) + 1;

                        return {
                            ...post,
                            like: !isLiked,
                            likeCount: newLikeCount,
                        };
                    }
                    return post;
                });

                return {
                    ...prevList,
                    content: updatedContent,
                };
            });

        } catch (error) {
            console.error("좋아요 토글 실패:", error);
        }
    };



    return (
        <>

            {showAlert && (
                <Alert
                    title="알림"
                    message={alertMessage}
                    onClose={() => setShowAlert(false)}
                />
            )}


            {isMobile ? <PostCardMobile postCardList={postCardList} currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                selectedGenreIndex={selectedGenreIndex}
                setSelectedGenreIndex={setSelectedGenreIndex}
                onToggleLike={toggleLike}
            />
                :
                <GoodsPage postCardList={postCardList} currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                    selectedGenreIndex={selectedGenreIndex}
                    setSelectedGenreIndex={setSelectedGenreIndex}
                    onToggleLike={toggleLike}
                />}
        </>
    )


}

export default PostCardContainer;
